module.exports = __webpack_public_path__ + "static/media/triangle-music.9d7bb8dc.svg";